// import React, { useState, useEffect } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   IconButton,
//   Box,
//   Grid,
//   Typography,
//   CircularProgress,
//   Select,
//   MenuItem,
// } from "@mui/material";
// import {
//   Close as CloseIcon,
//   ZoomIn as ZoomInIcon,
//   Download as DownloadIcon
// } from "@mui/icons-material";
// import useFetchWithMsal from "../../hooks/useFetchWithMsal";
// import PdfViewer from "../PdfViewer";
// import { protectedResources } from "../../authConfig";

// const DocumentViewer = ({ open, onClose, invoice }) => {
//   const [invoiceContent, setInvoiceContent] = useState(null);
//   const [selectedAdditionalFile, setSelectedAdditionalFile] = useState(null);
//   const [additionalFileContent, setAdditionalFileContent] = useState(null);
//   const [loading, setLoading] = useState({
//     invoice: false,
//     additional: false
//   });

//   const { execute } = useFetchWithMsal({
//     scopes: protectedResources.apiScopes.scopes.read,
//   });

//   useEffect(() => {
//     if (invoice && open) {
//       // Load invoice
//       if (invoice?.FilePaths?.invoiceUrl) {
//         handleLoadInvoice();
//       }
//       // Load first additional document by default
//       if (invoice?.FilePaths?.additionalUrls?.[0]) {
//         const firstAdditionalUrl = invoice.FilePaths.additionalUrls[0];
//         setSelectedAdditionalFile(firstAdditionalUrl);
//         handleAdditionalFileSelect(firstAdditionalUrl);
//       }
//     }
//   }, [invoice, open]);

//   const fetchFileContent = async (fileUrl) => {
//     try {
//       const response = await execute(
//         "POST",
//         `${process.env.REACT_APP_BACKEND_BASE_URL}/api/checkInvoices/getFileContent`,
//         { fileUrl }
//       );

//       const responseData = response.data || response;

//       if (responseData?.success && responseData?.base64Content) {
//         const base64Content = responseData.base64Content;
//         return base64Content.startsWith("data:application/pdf;base64,")
//           ? base64Content
//           : `data:application/pdf;base64,${base64Content}`;
//       }
//       return null;
//     } catch (error) {
//       console.error("Error fetching file content:", error);
//       return null;
//     }
//   };

//   const handleLoadInvoice = async () => {
//     setLoading(prev => ({ ...prev, invoice: true }));
//     const content = await fetchFileContent(invoice.FilePaths.invoiceUrl);
//     setInvoiceContent(content);
//     setLoading(prev => ({ ...prev, invoice: false }));
//   };

//   const handleAdditionalFileSelect = async (fileUrl) => {
//     if (!fileUrl) return;
//     setSelectedAdditionalFile(fileUrl);
//     setLoading(prev => ({ ...prev, additional: true }));
//     const content = await fetchFileContent(fileUrl);
//     setAdditionalFileContent(content);
//     setLoading(prev => ({ ...prev, additional: false }));
//   };

//   const PdfContainer = ({ content, loading: isLoading, type }) => {
//     const [isFullScreen, setIsFullScreen] = useState(false);

//     const handleFullScreen = () => {
//       setIsFullScreen(true);
//     };

//     return (
//     <>
//       <Box sx={{ height: "100%", position: "relative" }}>
//         {isLoading ? (
//           <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
//             <CircularProgress />
//           </Box>
//         ) : content ? (
//           <Box sx={{ height: "100%", position: "relative" }}>
//             <Box sx={{ 
//               position: "absolute", 
//               top: '0.5%', 
//               right: '0.5%', 
//               zIndex: 1,
//               display: 'flex',
//               gap: '4px',
//               backgroundColor: 'rgba(255, 255, 255, 0.8)',
//               borderRadius: '4px',
//               p: '2px'
//             }}>
//               <IconButton 
//                 size="small" 
//                 onClick={handleFullScreen}
//                 sx={{ padding: '4px' }}
//               >
//                 <ZoomInIcon fontSize="small" />
//               </IconButton>
//               <IconButton
//                 size="small"
//                 component="a"
//                 href={content}
//                 download={`${type}.pdf`}
//                 sx={{ padding: '4px' }}
//               >
//                 <DownloadIcon fontSize="small" />
//               </IconButton>
//             </Box>
//             <Box 
//               onClick={handleFullScreen}
//               sx={{ 
//                 height: '100%',
//                 cursor: 'pointer'
//               }}
//             >
//               <PdfViewer fileContent={content} />
//             </Box>
//           </Box>
//         ) : (
//           <Box sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
//             <Typography color="textSecondary">
//               {type === 'invoice' 
//                 ? invoice?.FilePaths?.invoiceUrl 
//                   ? 'טוען חשבונית...' 
//                   : 'לא נמצאה חשבונית'
//                 : invoice?.FilePaths?.additionalUrls?.length 
//                   ? 'בחר מסמך מהרשימה כדי להציג אותו'
//                   : 'לא נמצאו מסמכים נוספים'
//               }
//             </Typography>
//           </Box>
//         )}
//       </Box>

//       <Dialog
//         open={isFullScreen}
//         onClose={() => setIsFullScreen(false)}
//         maxWidth={false}
//         fullScreen
//       >
//         <DialogTitle sx={{ 
//           m: 0, 
//           p: '0.5%',
//           minHeight: '35px',
//           display: "flex", 
//           justifyContent: "space-between", 
//           alignItems: "center",
//           borderBottom: 1,
//           borderColor: "divider"
//         }}>
//           <Typography variant="subtitle1">
//             {type === 'invoice' ? 'חשבונית' : 'מסמך נוסף'}
//           </Typography>
//           <IconButton onClick={() => setIsFullScreen(false)}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent sx={{ p: 0, height: '100%' }}>
//           <Box 
//             sx={{ 
//               height: '100%',
//               cursor: 'pointer'
//             }}
//             onClick={() => setIsFullScreen(false)}
//           >
//             <PdfViewer fileContent={content} />
//           </Box>
//         </DialogContent>
//       </Dialog>
//     </>
//     );
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth={false}
//       fullWidth
//       PaperProps={{
//         sx: {
//           height: { xs: "100vh", md: "99vh" },
//           width: { xs: "100vw", md: "99.5vw" },
//           margin: { xs: 0, md: "2px" },
//           display: "flex",
//           flexDirection: "column",
//         },
//       }}
//     >
//       <DialogTitle sx={{ 
//         m: 0, 
//         p: { xs: '0.8%', md: '0.5%' },
//         minHeight: { xs: '45px', md: '35px' },
//         display: "flex", 
//         justifyContent: "space-between", 
//         alignItems: "center"
//       }}>
//         <Typography variant="h6" sx={{ fontSize: { xs: '1rem', md: '1.25rem' } }}>
//           מסמכי חשבונית {invoice?.InvoiceProperties?.InvoiceNumber}
//         </Typography>
//         <IconButton 
//           onClick={onClose} 
//           sx={{ 
//             position: "absolute", 
//             right: { xs: '2%', md: '0.5%' }, 
//             top: '50%', 
//             transform: 'translateY(-50%)'
//           }}
//         >
//           <CloseIcon />
//         </IconButton>
//       </DialogTitle>

//       <DialogContent dividers sx={{ display: "flex", p: 0, overflow: "hidden", flex: 1 }}>
//         <Grid container sx={{ height: "100%" }}>
//           {/* Right Panel - Invoice (will be on top in mobile) */}
//           <Grid item xs={12} md={6} sx={{ 
//             height: { xs: "50%", md: "100%" },
//             display: "flex",
//             flexDirection: "column",
//             p: 0,
//             order: { xs: 1, md: 2 } // Move to top on mobile
//           }}>
//             <Box sx={{ 
//               display: "flex",
//               alignItems: "center",
//               p: '0.3%',
//               minHeight: '35px',
//               borderBottom: 1,
//               borderColor: "divider",
//               backgroundColor: "background.default"
//             }}>
//               <Typography variant="subtitle1" sx={{ fontSize: '0.9rem' }}>
//                 חשבונית
//               </Typography>
//             </Box>
//             <Box sx={{ 
//               flex: 1,
//               overflow: "hidden",
//               px: '0.1%',
//               pt: '0.1%'
//             }}>
//               <PdfContainer 
//                 content={invoiceContent} 
//                 loading={loading.invoice}
//                 type="invoice"
//               />
//             </Box>
//           </Grid>

//           {/* Left Panel - Additional Documents (will be on bottom in mobile) */}
//           <Grid item xs={12} md={6} sx={{ 
//             height: { xs: "50%", md: "100%" },
//             borderRight: { xs: 0, md: 1 },
//             borderTop: { xs: 1, md: 0 },
//             borderColor: "divider",
//             display: "flex",
//             flexDirection: "column",
//             p: 0,
//             order: { xs: 2, md: 1 } // Move to bottom on mobile
//           }}>
//             <Box sx={{ 
//               display: "flex",
//               alignItems: "center",
//               p: '0.3%',
//               minHeight: '35px',
//               borderBottom: 1,
//               borderColor: "divider",
//               backgroundColor: "background.default"
//             }}>
//               <Typography variant="subtitle1" sx={{ 
//                 mr: '1%', 
//                 whiteSpace: 'nowrap', 
//                 fontSize: { xs: '0.85rem', md: '0.9rem' }
//               }}>
//                 מסמכים נוספים:
//               </Typography>
//               <Box sx={{ 
//                 flex: 1,
//                 minWidth: 0,
//                 ml: '0.3%'
//               }}>
//                 <Select
//                   value={selectedAdditionalFile || ''}
//                   onChange={(e) => handleAdditionalFileSelect(e.target.value)}
//                   sx={{ 
//                     width: '100%',
//                     height: { xs: '30px', md: '25px' },
//                     '& .MuiSelect-select': {
//                       py: 0,
//                       fontSize: { xs: '0.85rem', md: '0.9rem' }
//                     }
//                   }}
//                   displayEmpty
//                 >
//                   <MenuItem value="">
//                     <em>בחר מסמך</em>
//                   </MenuItem>
//                   {invoice?.FilePaths?.additionalUrls?.map((url, index) => {
//                     return (
//                       <MenuItem key={index} value={url}>
//                         {url.split('/').pop()}
//                       </MenuItem>
//                     );
//                   })}
//                 </Select>
//               </Box>
//             </Box>
//             <Box sx={{ 
//               flex: 1,
//               overflow: "hidden",
//               px: '0.1%',
//               pt: '0.1%'
//             }}>
//               <PdfContainer 
//                 content={additionalFileContent} 
//                 loading={loading.additional}
//                 type="additional"
//               />
//             </Box>
//           </Grid>
//         </Grid>
//       </DialogContent>
//     </Dialog>
//   );
// };

// export default DocumentViewer;
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Grid,
  Typography,
  CircularProgress,
  Select,
  MenuItem,
} from "@mui/material";
import {
  Close as CloseIcon,
  ZoomIn as ZoomInIcon,
  Download as DownloadIcon
} from "@mui/icons-material";
import useFetchWithMsal from "../../hooks/useFetchWithMsal";
import PdfViewer from "../PdfViewer";
import { protectedResources } from "../../authConfig";

const DocumentViewer = ({ open, onClose, invoice }) => {
  const [invoiceContent, setInvoiceContent] = useState(null);
  const [selectedAdditionalFile, setSelectedAdditionalFile] = useState(null);
  const [additionalFileContent, setAdditionalFileContent] = useState(null);
  const [loading, setLoading] = useState({
    invoice: false,
    additional: false
  });

  const { execute } = useFetchWithMsal({
    scopes: protectedResources.apiScopes.scopes.read,
  });

  useEffect(() => {
    if (invoice && open) {
      if (invoice?.FilePaths?.invoiceUrl) {
        handleLoadInvoice();
      }
      if (invoice?.FilePaths?.additionalUrls?.[0]) {
        const firstAdditionalUrl = invoice.FilePaths.additionalUrls[0];
        setSelectedAdditionalFile(firstAdditionalUrl);
        handleAdditionalFileSelect(firstAdditionalUrl);
      }
    }
  }, [invoice, open]);

  const fetchFileContent = async (fileUrl) => {
    try {
      const response = await execute(
        "POST",
        `${process.env.REACT_APP_BACKEND_BASE_URL}/api/checkInvoices/getFileContent`,
        { fileUrl }
      );

      const responseData = response.data || response;

      if (responseData?.success && responseData?.base64Content) {
        const base64Content = responseData.base64Content;
        return base64Content.startsWith("data:application/pdf;base64,")
          ? base64Content
          : `data:application/pdf;base64,${base64Content}`;
      }
      return null;
    } catch (error) {
      console.error("Error fetching file content:", error);
      return null;
    }
  };

  const handleLoadInvoice = async () => {
    setLoading(prev => ({ ...prev, invoice: true }));
    const content = await fetchFileContent(invoice.FilePaths.invoiceUrl);
    setInvoiceContent(content);
    setLoading(prev => ({ ...prev, invoice: false }));
  };

  const handleAdditionalFileSelect = async (fileUrl) => {
    if (!fileUrl) return;
    setSelectedAdditionalFile(fileUrl);
    setLoading(prev => ({ ...prev, additional: true }));
    const content = await fetchFileContent(fileUrl);
    setAdditionalFileContent(content);
    setLoading(prev => ({ ...prev, additional: false }));
  };

  const PdfContainer = ({ content, loading: isLoading, type }) => {
    const [isFullScreen, setIsFullScreen] = useState(false);

    const handleFullScreen = () => {
      setIsFullScreen(true);
    };

    return (
      <>
        <Box sx={{ height: "100%", position: "relative" }}>
          {isLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
              <CircularProgress />
            </Box>
          ) : content ? (
            <Box sx={{ height: "100%", position: "relative" }}>
              <Box sx={{ 
                position: "absolute", 
                top: '0.5%', 
                right: '0.5%', 
                zIndex: 1,
                display: 'flex',
                gap: '4px',
                bgcolor: 'rgba(0, 0, 0, 0.05)',
                borderRadius: '4px',
                p: '2px'
              }}>
                <IconButton 
                  size="small" 
                  onClick={handleFullScreen}
                  sx={{ 
                    padding: '4px',
                    color: '#666',
                    '&:hover': {
                      bgcolor: 'rgba(0, 0, 0, 0.05)',
                      color: '#333'
                    }
                  }}
                >
                  <ZoomInIcon fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  component="a"
                  href={content}
                  download={`${type}.pdf`}
                  sx={{ 
                    padding: '4px',
                    color: '#666',
                    '&:hover': {
                      bgcolor: 'rgba(0, 0, 0, 0.05)',
                      color: '#333'
                    }
                  }}
                >
                  <DownloadIcon fontSize="small" />
                </IconButton>
              </Box>
              <Box 
                onClick={handleFullScreen}
                sx={{ 
                  height: '100%',
                  cursor: 'pointer'
                }}
              >
                <PdfViewer fileContent={content} />
              </Box>
            </Box>
          ) : (
            <Box sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Typography color="textSecondary">
                {type === 'invoice' 
                  ? invoice?.FilePaths?.invoiceUrl 
                    ? 'טוען חשבונית...' 
                    : 'לא נמצאה חשבונית'
                  : invoice?.FilePaths?.additionalUrls?.length 
                    ? 'בחר מסמך מהרשימה כדי להציג אותו'
                    : 'לא נמצאו מסמכים נוספים'
                }
              </Typography>
            </Box>
          )}
        </Box>

        <Dialog
          open={isFullScreen}
          onClose={() => setIsFullScreen(false)}
          maxWidth={false}
          fullScreen
        >
          <DialogTitle sx={{ 
            m: 0, 
            p: '0.5%',
            minHeight: '35px',
            display: "flex", 
            justifyContent: "space-between", 
            alignItems: "center",
            borderBottom: 1,
            borderColor: "divider",
            bgcolor: '#f5f5f5'
          }}>
            <Typography variant="subtitle1" sx={{ color: '#333' }}>
              {type === 'invoice' ? 'חשבונית' : 'מסמך נוסף'}
            </Typography>
            <IconButton onClick={() => setIsFullScreen(false)} sx={{ color: '#666' }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ p: 0, height: '100%' }}>
            <Box 
              sx={{ 
                height: '100%',
                cursor: 'pointer'
              }}
              onClick={() => setIsFullScreen(false)}
            >
              <PdfViewer fileContent={content} />
            </Box>
          </DialogContent>
        </Dialog>
      </>
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: {
          height: { xs: "100vh", md: "99vh" },
          width: { xs: "100vw", md: "99.5vw" },
          margin: { xs: 0, md: "2px" },
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <DialogTitle sx={{ 
        m: 0, 
        p: { xs: '0.8%', md: '0.5%' },
        minHeight: { xs: '45px', md: '35px' },
        display: "flex", 
        justifyContent: "space-between", 
        alignItems: "center",
        bgcolor: '#ebf7ff',
        borderBottom: 1,
        borderColor: 'divider'
      }}>
        <Typography variant="h6" sx={{ fontSize: { xs: '1rem', md: '1.25rem' }, color: '#333' }}>
          מסמכי חשבונית {invoice?.InvoiceProperties?.InvoiceNumber}
        </Typography>
        <IconButton 
          onClick={onClose} 
          sx={{ 
            position: "absolute", 
            right: { xs: '2%', md: '0.5%' }, 
            top: '50%', 
            transform: 'translateY(-50%)',
            color: '#666',
            '&:hover': {
              bgcolor: 'rgba(0, 0, 0, 0.04)'
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ display: "flex", p: 0, overflow: "hidden", flex: 1, bgcolor: '#fff' }}>
        <Grid container sx={{ height: "100%" }}>
          {/* Right Panel - Invoice */}
          <Grid item xs={12} md={6} sx={{ 
            height: { xs: "50%", md: "100%" },
            display: "flex",
            flexDirection: "column",
            p: 0,
            order: { xs: 1, md: 2 }
          }}>
            <Box sx={{ 
              display: "flex",
              alignItems: "center",
              p: '0.3%',
              minHeight: '35px',
              borderBottom: 1,
              borderColor: "divider",
              bgcolor: '#f5f5f5'
            }}>
              <Typography variant="subtitle1" sx={{ fontSize: '0.9rem', fontWeight: 500, color: '#333' }}>
                חשבונית
              </Typography>
            </Box>
            <Box sx={{ 
              flex: 1,
              overflow: "hidden",
              px: '0.1%',
              pt: '0.1%'
            }}>
              <PdfContainer 
                content={invoiceContent} 
                loading={loading.invoice}
                type="invoice"
              />
            </Box>
          </Grid>

          {/* Left Panel - Additional Documents */}
          <Grid item xs={12} md={6} sx={{ 
            height: { xs: "50%", md: "100%" },
            borderRight: { xs: 0, md: 1 },
            borderTop: { xs: 1, md: 0 },
            borderColor: "divider",
            display: "flex",
            flexDirection: "column",
            p: 0,
            order: { xs: 2, md: 1 }
          }}>
            <Box sx={{ 
              display: "flex",
              alignItems: "center",
              p: '0.3%',
              minHeight: '35px',
              borderBottom: 1,
              borderColor: "divider",
              bgcolor: '#f5f5f5'
            }}>
              <Typography variant="subtitle1" sx={{ 
                mr: '1%', 
                whiteSpace: 'nowrap', 
                fontSize: { xs: '0.85rem', md: '0.9rem' },
                fontWeight: 500,
                color: '#333'
              }}>
                מסמכים נוספים:
              </Typography>
              <Box sx={{ 
                flex: 1,
                minWidth: 0,
                ml: '0.3%'
              }}>
                <Select
                  value={selectedAdditionalFile || ''}
                  onChange={(e) => handleAdditionalFileSelect(e.target.value)}
                  sx={{ 
                    width: '100%',
                    height: { xs: '30px', md: '25px' },
                    backgroundColor: 'white',
                    '& .MuiSelect-select': {
                      py: 0,
                      fontSize: { xs: '0.85rem', md: '0.9rem' }
                    },
                    '&:hover': {
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#999'
                      }
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#666'
                    }
                  }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>בחר מסמך</em>
                  </MenuItem>
                  {invoice?.FilePaths?.additionalUrls?.map((url, index) => (
                    <MenuItem key={index} value={url}>
                      {url.split('/').pop()}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </Box>
            <Box sx={{ 
              flex: 1,
              overflow: "hidden",
              px: '0.1%',
              pt: '0.1%'
            }}>
              <PdfContainer 
                content={additionalFileContent} 
                loading={loading.additional}
                type="additional"
              />
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default DocumentViewer;